export const report = (error: string | Error) => window?.Honeybadger?.notify?.((error as Error).message ?? error)
